module.exports = __webpack_public_path__ + "static/media/boost-your-post-for-increasing-sales.40703f06.md";